import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

// Attach JWT from localStorage as fallback for environments where cookies
// don't survive cross-site iframe sandboxes (e.g. the Emergent preview).
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('chimera_admin_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminLogin = (username, password) =>
  api.post('/api/admin/login', { username, password });
export const adminLogout = () => api.post('/api/admin/logout');
export const adminMe = () => api.get('/api/admin/me');

export const fetchItems = (type) => api.get(`/api/admin/items?type=${type}`);
export const createItem = (type, payload) =>
  api.post(`/api/admin/items?type=${type}`, payload);
export const updateItem = (type, id, payload) =>
  api.patch(`/api/admin/items/${id}?type=${type}`, payload);
export const deleteItem = (type, id) =>
  api.delete(`/api/admin/items/${id}?type=${type}`);

export const fetchAdminArtists = () => api.get('/api/admin/artists');
export const createArtist = (payload) => api.post('/api/admin/artists', payload);
export const updateArtist = (slug, payload) =>
  api.patch(`/api/admin/artists/${slug}`, payload);
export const deleteArtist = (slug) => api.delete(`/api/admin/artists/${slug}`);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/api/admin/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const syncToProd = (username, password) =>
  api.post('/api/admin/sync-to-prod', { username, password });

export const renderInSitu = ({ type, id, mode }) =>
  api.post('/api/admin/render-insitu', { type, id, mode });

// French translation (single item, for the admin "Translate to FR" button)
export const translateToFr = ({ title, description }) =>
  api.post('/api/admin/translate', { title, description });

// Regenerate sitemap.xml from current DB
export const regenerateSitemap = () => api.post('/api/admin/regenerate-sitemap');

// Instagram (curated feed)
export const fetchInstagramAdmin = () => api.get('/api/admin/instagram');
export const saveInstagram = ({ handle, posts }) =>
  api.put('/api/admin/instagram', { handle, posts });
export const publicInstagram = () => api.get('/api/public/instagram');

// Promo video
export const fetchPromoVideoAdmin = () => api.get('/api/admin/promo-video');
export const savePromoVideo = ({ url, enabled, caption }) =>
  api.put('/api/admin/promo-video', { url, enabled, caption });
export const publicPromoVideo = () => api.get('/api/public/promo-video');

// Newsletter
export const subscribeNewsletter = (email, lang = 'en') =>
  api.post('/api/subscribe', { email, lang });

export const fetchSubscribers = () => api.get('/api/admin/subscribers');
export const deleteSubscriber = (id) => api.delete(`/api/admin/subscribers/${id}`);
export const sendNewsletter = ({ subject, html }) =>
  api.post('/api/admin/newsletter/send', { subject, html });


export const publicGallery = () => api.get('/api/public/gallery');
export const publicAntiques = () => api.get('/api/public/antiques');
export const publicArtists = () => api.get('/api/public/artists');
